var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _circle2, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIco4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1257 21.2559C13.8573 20.1949 14.5097 19.1197 15.5748 18.8678L29.2273 15.6396C30.1984 15.41 31.187 15.9466 31.5235 16.8861L33.2897 21.8176C33.6711 22.8826 33.0742 24.0485 31.9872 24.3618L18.0178 28.3871C16.9535 28.6938 15.8467 28.0582 15.5751 26.9845L14.1257 21.2559Z",
    fill: "#88AE45",
    stroke: "#503530",
    strokeWidth: 0.435545
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03568 14.6671C9.46583 14.6671 9.81453 14.3184 9.81453 13.8882C9.81453 13.4581 9.46583 13.1094 9.03568 13.1094C8.60554 13.1094 8.25684 13.4581 8.25684 13.8882C8.25684 14.3184 8.60554 14.6671 9.03568 14.6671Z",
    fill: "#EE3E54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9588 8.04691C34.1738 8.04691 34.3482 7.87256 34.3482 7.65749C34.3482 7.44242 34.1738 7.26807 33.9588 7.26807C33.7437 7.26807 33.5693 7.44242 33.5693 7.65749C33.5693 7.87256 33.7437 8.04691 33.9588 8.04691Z",
    fill: "#F1BC19"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4448 36.476C31.4025 36.476 37.8534 30.025 37.8534 22.0673C37.8534 14.1097 31.4025 7.65869 23.4448 7.65869C15.4871 7.65869 9.03613 14.1097 9.03613 22.0673C9.03613 30.025 15.4871 36.476 23.4448 36.476Z",
    fill: "#C0E5E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.295 9.99478C37.1553 9.99478 37.8527 9.29738 37.8527 8.43709C37.8527 7.5768 37.1553 6.87939 36.295 6.87939C35.4347 6.87939 34.7373 7.5768 34.7373 8.43709C34.7373 9.29738 35.4347 9.99478 36.295 9.99478Z",
    fill: "#F1BC19"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8536 12.7203C38.2837 12.7203 38.6324 12.3716 38.6324 11.9414C38.6324 11.5113 38.2837 11.1626 37.8536 11.1626C37.4234 11.1626 37.0747 11.5113 37.0747 11.9414C37.0747 12.3716 37.4234 12.7203 37.8536 12.7203Z",
    fill: "#EE3E54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5162 32.9703C35.9463 32.9703 36.295 32.6216 36.295 32.1914C36.295 31.7613 35.9463 31.4126 35.5162 31.4126C35.086 31.4126 34.7373 31.7613 34.7373 32.1914C34.7373 32.6216 35.086 32.9703 35.5162 32.9703Z",
    fill: "#FBCD59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81453 28.6867C10.6748 28.6867 11.3722 27.9893 11.3722 27.129C11.3722 26.2687 10.6748 25.5713 9.81453 25.5713C8.95424 25.5713 8.25684 26.2687 8.25684 27.129C8.25684 27.9893 8.95424 28.6867 9.81453 28.6867Z",
    fill: "#FBCD59"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.709 37.255C14.1392 37.255 14.4879 36.9063 14.4879 36.4761C14.4879 36.046 14.1392 35.6973 13.709 35.6973C13.2789 35.6973 12.9302 36.046 12.9302 36.4761C12.9302 36.9063 13.2789 37.255 13.709 37.255Z",
    fill: "#EE3E54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1777 24.4037C11.7153 24.4037 12.1512 23.9678 12.1512 23.4301C12.1512 22.8924 11.7153 22.4565 11.1777 22.4565C10.64 22.4565 10.2041 22.8924 10.2041 23.4301C10.2041 23.9678 10.64 24.4037 11.1777 24.4037Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1516 29.0767C12.3667 29.0767 12.5411 28.9023 12.5411 28.6873C12.5411 28.4722 12.3667 28.2979 12.1516 28.2979C11.9366 28.2979 11.7622 28.4722 11.7622 28.6873C11.7622 28.9023 11.9366 29.0767 12.1516 29.0767Z",
    fill: "#F1BC19"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1267 16.2261C35.3418 16.2261 35.5162 16.0518 35.5162 15.8367C35.5162 15.6216 35.3418 15.4473 35.1267 15.4473C34.9117 15.4473 34.7373 15.6216 34.7373 15.8367C34.7373 16.0518 34.9117 16.2261 35.1267 16.2261Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0174 20.6985C12.7366 19.6407 13.3766 18.5579 14.4386 18.2938L28.0527 14.9073C29.0211 14.6664 30.0159 15.1915 30.3632 16.127L32.1865 21.0377C32.5803 22.0982 31.997 23.271 30.9137 23.5968L16.992 27.784C15.9313 28.103 14.8172 27.4804 14.5331 26.4099L13.0174 20.6985Z",
    fill: "#C0D078",
    stroke: "#503530",
    strokeWidth: 0.435545
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.885 21.7635C14.6534 20.7359 15.2755 19.709 16.2935 19.4384L27.1431 16.5542C28.1563 16.2848 29.2021 16.8605 29.5164 17.8607L30.2923 20.3293C30.6237 21.3839 30.0179 22.5038 28.9539 22.8035L17.9343 25.9075C16.8532 26.2121 15.7378 25.5476 15.4909 24.4519L14.885 21.7635Z",
    fill: "#88AE45",
    stroke: "#503530",
    strokeWidth: 0.435545
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.105 21.0857C25.105 22.2144 24.19 23.1294 23.0613 23.1294C21.9326 23.1294 21.0176 22.2144 21.0176 21.0857C21.0176 19.957 21.9326 19.042 23.0613 19.042C24.19 19.042 25.105 19.957 25.105 21.0857Z",
    fill: "#C0D078",
    stroke: "#605536",
    strokeWidth: 0.435545
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.0258,
    cy: 20.331,
    r: 0.724512,
    fill: "#C0D078",
    stroke: "#605536",
    strokeWidth: 0.435545
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1122,
    cy: 22.2172,
    r: 0.724512,
    fill: "#C0D078",
    stroke: "#605536",
    strokeWidth: 0.435545
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9293 22.779C34.9293 24.1257 33.8376 25.2174 32.4909 25.2174C31.1442 25.2174 30.0525 24.1257 30.0525 22.779C30.0525 21.4323 31.1442 20.3406 32.4909 20.3406C33.8376 20.3406 34.9293 21.4323 34.9293 22.779Z",
    fill: "#FBCD59",
    stroke: "#4B2F2A",
    strokeWidth: 0.4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6093 22.7782C33.6093 23.3963 33.1082 23.8974 32.4901 23.8974C31.872 23.8974 31.3709 23.3963 31.3709 22.7782C31.3709 22.1601 31.872 21.659 32.4901 21.659C33.1082 21.659 33.6093 22.1601 33.6093 22.7782Z",
    fill: "#F1BC19",
    stroke: "#4B2F2A",
    strokeWidth: 0.4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4256 23.8984V22.7975L32.5222 22.8974H32.175V22.7128H32.6458V23.8984H32.4256Z",
    fill: "#503530"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1618 25.4143C31.1618 26.761 30.07 27.8527 28.7234 27.8527C27.3767 27.8527 26.285 26.761 26.285 25.4143C26.285 24.0676 27.3767 22.9759 28.7234 22.9759C30.07 22.9759 31.1618 24.0676 31.1618 25.4143Z",
    fill: "#FBCD59",
    stroke: "#4B2F2A",
    strokeWidth: 0.4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8417 25.4134C29.8417 26.0316 29.3406 26.5326 28.7225 26.5326C28.1044 26.5326 27.6033 26.0316 27.6033 25.4134C27.6033 24.7953 28.1044 24.2942 28.7225 24.2942C29.3406 24.2942 29.8417 24.7953 29.8417 25.4134Z",
    fill: "#F1BC19",
    stroke: "#4B2F2A",
    strokeWidth: 0.4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5804 26.231V25.13L28.677 25.2299H28.3298V25.0453H28.8006V26.231H28.5804Z",
    fill: "#503530"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco4);
export default __webpack_public_path__ + "static/media/ico4.24fa4c8fe91bfbe70765ca88910ff057.svg";
export { ForwardRef as ReactComponent };